<template>
  <member-empty-link :emptyLayout="emptyLayout" v-if="memberData.length === 0"></member-empty-link>
  <member-list-link :memberData="memberData" :listLayout="listLayout" v-else></member-list-link>
</template>

<script>
import MemberListLink from "@/components/member/MemberListLink";
import memberUtil from "@/components/member/memberUtil";
import MemberEmptyLink from "@/components/member/MemberEmptyLink";

export default {
  name: "MemberHomeComponent",
  mixins: [memberUtil],
  components: {MemberEmptyLink, MemberListLink},
  inject: [],
  provide() {
    return {}
  },
  props: {
    memberType: '',
  },
  data() {
    return {
      listLayout: '',
      emptyLayout: '',
      getFunc: '',
      listApiParamSet: {},
      memberData: [],
    }
  },
  beforeRouterEnter() {
  },
  created() {
    this.initConfig();
    this.getList();
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    initConfig() {
      let memberConfig = this.returnMemberConfig(this.memberType);
      this.listLayout = memberConfig.listLayout;
      this.emptyLayout = memberConfig.emptyLayout;
      this.listApiParamSet = memberConfig.listApiParamSet;
      this.getFunc = memberConfig.getFunc;
    },
    getList() {
      let params = JSON.parse(JSON.stringify(this.listApiParamSet));
      try {
        this.$api.$member[this.getFunc](params).then(res => res.Data.Result).then(res => {
          if (res.Info.type != 1) {
            this.errorAlert('게시글 목록을 불러올 수 없습니다.');
            return false;
          }
          this.memberData = res.List;
        })
      } catch (e) {
        this.errorAlert(e);
      }
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>
